export enum CustomLoginModeEnum {
  Login = 'login',
  Registration = 'registration',
  Request = 'request',
  Reset = 'reset',
}
